import { jsx } from 'react/jsx-runtime';

// src/icons/spinner.tsx
var Spinner = () => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1.25rem",
      height: "1.25rem",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: /* @__PURE__ */ jsx(
        "circle",
        {
          cx: "50",
          cy: "50",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "8",
          r: "35",
          strokeDasharray: "164.93361431346415 56.97787143782138",
          children: /* @__PURE__ */ jsx(
            "animateTransform",
            {
              attributeName: "transform",
              type: "rotate",
              repeatCount: "indefinite",
              dur: "1.25s",
              values: "0 50 50;360 50 50",
              keyTimes: "0;1"
            }
          )
        }
      )
    }
  );
};

export { Spinner };
